'use client';

import { c as _c } from "react/compiler-runtime";
import { Heading } from 'design-system/client';
import { useTranslations } from 'next-intl';
import styles from './IFrameExplanation.module.css';
function IFrameExplanation() {
  const $ = _c(16);
  const t = useTranslations("nextjs.donate.iframe");
  let t0;
  if ($[0] !== t) {
    t0 = t("codonation_intro_title");
    $[0] = t;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== t0) {
    t1 = <Heading level="text-md-important" as="h2">{t0}</Heading>;
    $[2] = t0;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== t) {
    t2 = t("codonation_intro_body");
    $[4] = t;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== t2) {
    t3 = <p className={styles.body}>{t2}</p>;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== t) {
    t4 = t("codonation_intro_cta");
    $[8] = t;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== t4) {
    t5 = <strong className={styles.callToAction}>{t4}</strong>;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== t1 || $[13] !== t3 || $[14] !== t5) {
    t6 = <div>{t1}{t3}{t5}</div>;
    $[12] = t1;
    $[13] = t3;
    $[14] = t5;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  return t6;
}
export default IFrameExplanation;